import { LinearGradient } from "expo-linear-gradient";
import { Box, Stack, VStack } from "native-base";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";
import styled from "styled-components/native";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

const OrderTrackingLoading = () => {
  return (
    <>
      <Box p="4" rounded="md" py="2">
        <Loader height={20} />
      </Box>
      <Stack
        h="100%"
        w="100%"
        p="4"
        pb="32"
        direction={{
          base: "column",
          lg: "row",
        }}
        justifyContent={{
          base: "flex-start",
          lg: "space-between",
        }}>
        <Stack
          direction={{
            base: "column",
            lg: "row",
          }}
          space={{
            base: 1,
            lg: 8,
          }}
          w={{
            base: "100%",
            lg: "40%",
          }}>
          <Box
            h={{
              base: "60px",
              lg: "100%",
            }}
            w="100%">
            <Loader />
          </Box>
        </Stack>
        <VStack
          w={{
            base: "100%",
            lg: "55%",
          }}>
          <Box rounded="md" pt="0" py="2">
            <Loader height={80} />
          </Box>
          <Box rounded="md" py="2">
            <Loader height={120} />
          </Box>
          <Box rounded="md" py="2">
            <Loader height={40} />
          </Box>
          <Box rounded="md" py="2">
            <Loader height={100} />
          </Box>
          <Box rounded="md" py="2">
            <Loader height={100} />
          </Box>
          <Box rounded="md" py="2">
            <Loader height={100} />
          </Box>
        </VStack>
      </Stack>
    </>
  );
};

const Loader = styled(ShimmerPlaceholder)`
  width: ${({ width }) => (width ? width + "px" : "100%")};
  height: ${({ height }) => (height ? height + "px" : "100%")};
`;

export default OrderTrackingLoading;
